import { Link, useLocation } from 'react-router';
import { ErrorState } from '@/components/common/ErrorState';
import { Button } from '@/components/ui/button';
import { ROUTES } from '@/config/routes';
/** 콘텐츠/이미지 import 없이 chunk 실패에서도 목록 복귀를 제공한다. */
export function CertificationRouteError() {
  const { pathname } = useLocation();
  const paths = pathname.startsWith(`${ROUTES.workspace.mobile.root}/`)
    ? ROUTES.workspace.mobile
    : ROUTES.workspace;
  return (
    <div className="space-y-4">
      <ErrorState
        message="인증 안내를 다시 불러오거나 목록으로 이동하세요."
        onRetry={() => window.location.reload()}
      />
      <Button asChild variant="outline">
        <Link
          to={
            pathname.startsWith(ROUTES.workspace.root)
              ? paths.certifications
              : ROUTES.certifications
          }
        >
          인증 목록으로
        </Link>
      </Button>
    </div>
  );
}
